import { AxiosResponse } from 'axios';
import { CoordinateSystem } from 'geojson-transformer';
import v2 from '../v2';

export interface IRoadNear {
  _id: string;
  creator: {
    cert: { name: string },
  };
  line: {
    hash: string,
    geometry: GeoJSON.LineString,
    gcj02Geometry: GeoJSON.LineString,
  };
  length: number;
  removed: boolean;
  roadType: number,
}

export async function roadNet(file: File): Promise<AxiosResponse<any>> {
  const form = new FormData();
  form.append('file', file);
  return v2({
    url: 'operation/roadNet/batchImport',
    method: 'post',
    data: form,
  });
}

export async function findNear(center: ILngLat, radius: number, coordinateSystem: CoordinateSystem): Promise<AxiosResponse<IRoadNear[]>> {
  return v2({
    url: 'operation/roadNet/byLocation',
    params: {
      center, radius, coordinateSystem,
    },
  });
}

export async function updateById(id: string, coordinates: ILngLat[], coordinateSystem: CoordinateSystem = 'wgs84'): Promise<AxiosResponse<void>> {
  return v2({
    url: `operation/roadNet/${id}/line`,
    method: 'put',
    data: {
      coordinates,
      coordinateSystem,
    },
  });
}

export async function create(coordinates: ILngLat[], roadType?: number, coordinateSystem: CoordinateSystem = 'wgs84'): Promise<AxiosResponse<IRoadNear>> {
  return v2({
    url: 'operation/roadNet',
    method: 'post',
    data: {
      coordinates,
      coordinateSystem,
      roadType,
    },
  });
}

export async function removeById(id: string): Promise<AxiosResponse<void>> {
  return v2({
    url: `operation/roadNet/${id}`,
    method: 'delete',
  });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/api/operation/roadNet.ts